<template>
  <v-text-field
    v-model="value"
    @click:clear="handleClear()"
    outlined
    dense
    single-line
    prepend-inner-icon="mdi-magnify"
    :label="__('pesquisar')"
    v-bind="$attrs"
    clearable
    :hide-details="hideDetails"
  ></v-text-field>
</template>

<script>
import i18n from "@/mixins/i18n";
import _ from "lodash";

export default {
  mixins: [i18n],

  components: {},

  props: {
    urlKey: {
      type: String,
      default: "search",
    },
    search: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
  },

  model: {
    prop: "search",
    event: "search",
  },

  data() {
    return {
      i18n_prefix: "settings",
      value: "",
    };
  },

  methods: {
    handleUpdate() {
      this.$emit("search", this.value);
    },
    handleClear() {
      this.value = "";
    },
  },

  computed: {},

  watch: {
    value: _.debounce(async function (value) {
      this.handleUpdate();
    }, 500),
    search(value) {
      this.value = value;
    },
  },
};
</script>
